import OfferWeb from '../../../assets/svg/couponLarge.svg';
import OfferMobile from '../../../assets/svg/couponSmall.svg';
import DEOfferMobile_Smartline from '../../../assets/svg/offers/de-offer1-mobile.svg';
import DEOfferWeb_Smartline from '../../../assets/svg/offers/de-offer1-web.svg';
import DEOfferMobile_Tractor from '../../../assets/svg/offers/de-offer2-mobile.svg';
import DEOfferWeb_Tractor from '../../../assets/svg/offers/de-offer2-web.svg';
import DEOfferWeb_Calculator from '../../../assets/svg/offers/de-offer3-web.svg';
import DEOfferMobile_Calculator from '../../../assets/svg/offers/de-offer3-mobile.svg';
import GBOfferMobile_Tractor from '../../../assets/svg/offers/gb-offer1-mobile.svg';
import GBOfferWeb_Tractor from '../../../assets/svg/offers/gb-offer1-web.svg';
import GBOfferMobile_Smartline from '../../../assets/svg/offers/gb-offer2-mobile.svg';
import GBOfferWeb_Smartline from '../../../assets/svg/offers/gb-offer2-web.svg';
import GBOfferWeb_Calculator from '../../../assets/svg/offers/gb-offer3-web.svg';
import GBOfferMobile_Calculator from '../../../assets/svg/offers/gb-offer3-mobile.svg';
import {GERMANY_COUNTRY_CODE} from '../../../utils/constant';
import Smartlook from '../../../utils/smartlook';
import {
  OpenWebURL,
  sendCustomDataNR,
  sendScreenViewNR,
} from '../../../utils/util';
import SkeletonLoader from '../../skeletonLoader/SkeletonLoader';

import {Button} from '@deere/fuel-react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PropTypes from 'prop-types';
import React from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {Carousel} from 'react-responsive-carousel';
import {postAPICall} from '../../../services/apiCallsHandler';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './CustomerOffer.css';

const CustomerOffer = (props) => {
  const {t} = useTranslation();
  const [isMobile, setIsMobile] = React.useState(false);

  const urlMapping = {
    de: 'https://jdfcalculator.deere.com/offers/de_DE',
    gb: 'https://jdfcalculator.deere.com/offers/en_UK',
    es: 'https://jdfcalculator.deere.com/offers/es_ES',
  };

  const offerImageCarouselData = {
    de: [
      {
        id: '1-DESmartline',
        offerName: 'DE SmartLine Offer',
        webImage: DEOfferWeb_Smartline,
        mobileImage: DEOfferMobile_Smartline,
        url: 'https://www.deere.de/de-de/finanzierung/smartline?cid=MFA_JDF_deDE_MFA-SmartLine-Banner_Banner-DE-A1',
      },
      {
        id: '2-DETractor',
        offerName: 'DE Tractor Offer',
        webImage: DEOfferWeb_Tractor,
        mobileImage: DEOfferMobile_Tractor,
        url: 'https://jdfcalculator.deere.com/126',
        validTill: '2099-12-31',
      },
      {
        id: '3-DECalculator',
        offerName: 'DE Calculator Offer',
        webImage: DEOfferWeb_Calculator,
        mobileImage: DEOfferMobile_Calculator,
        url: 'https://jdfcalculator.deere.com/offers/de_DE',
      },
    ],
    gb: [
      {
        id: '1-GBSmartline',
        offerName: 'GB SmartLine Offer',
        webImage: GBOfferWeb_Smartline,
        mobileImage: GBOfferMobile_Smartline,
        url: 'https://www.deere.co.uk/en-gb/financing/smartline?cid=MFA_JDF_enGB_MFA-SmartLine-Banner_Banner-EN-A1',
      },
      {
        id: '2-GBTractor',
        offerName: 'GB Tractor Offer',
        webImage: GBOfferWeb_Tractor,
        mobileImage: GBOfferMobile_Tractor,
        url: 'https://jdfcalculator.deere.com/216',
      },
      {
        id: '3-GBCalculator',
        offerName: 'GB Calculator Offer',
        webImage: GBOfferWeb_Calculator,
        mobileImage: GBOfferMobile_Calculator,
        url: 'https://jdfcalculator.deere.com/offers/en_UK',
      },
    ],
    es: [],
  };

  const checkIsMobile = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  React.useEffect(() => {
    sendScreenViewNR('CustomerOffer');
    Smartlook.navigation('CustomerOffer');
  }, []);

  React.useEffect(() => {
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  const trackOfferBannerClick = (offerId, offerName) => {
    postAPICall(
      'offerBannerClick',
      {
        offerId,
        offerName,
        country: props.country || '',
      },
      {
        errorTag: 'OFFER_BANNER_CLICK',
        redirectToOops: false,
      }
    );
  };

  const handleOfferClick = (offerId, offerName, url) => {
    sendCustomDataNR(
      'Offer',
      sessionStorage.getItem('trace-id'),
      props.country,
      null,
      'OFFER_CLICKED'
    );
    trackOfferBannerClick(offerId, offerName);
    OpenWebURL('weburl', url);
  };

  let content;

  if (props.paymentScheduleLoader) {
    content = <SkeletonLoader componentName="nextInstallment" />;
  } else {
    const carouselItems = [];
    if (
      props.country === GERMANY_COUNTRY_CODE &&
      props.validOfferCode &&
      props.validOfferCode !== ''
    ) {
      carouselItems.push(
        <div key="offer">
          <div className="customer-offer-image">
            {isMobile ? (
              <img loading="lazy" src={OfferMobile} alt="Offer" />
            ) : (
              <img loading="lazy" src={OfferWeb} alt="Offer" />
            )}
          </div>
          <div className="customer-offer-text">
            <div className="customer-offer-text-title">
              {t('CUSTOMER_OFFER_DESC')}
            </div>
            <div className="redirectToShop">
              {' '}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleOfferClick(
                    '0-DEShopLink',
                    'DE Shop Link Offer',
                    'https://www.johndeereshop.com/de/'
                  );
                }}
              >
                {t('CUSTOMER_OFFER_SHOP_LINK')}
              </a>
            </div>
            <div className="customer-offer-code">
              <p>{props.validOfferCode}</p>
              <CopyToClipboard text={props.validOfferCode}>
                <Button variant="primary"> {t('COPY_BUTTON')}</Button>
              </CopyToClipboard>
            </div>
          </div>
        </div>
      );
    }

    offerImageCarouselData &&
      offerImageCarouselData[props.country]
        ?.filter((item) => {
          if (!item.validTill) return true;
          const today = new Date();
          const validTillDate = new Date(item.validTill);
          return today <= validTillDate;
        })
        .forEach((item) => {
          carouselItems.push(
            <div key={item.id}>
              <div
                className="customer-offer-image"
                role="button"
                tabIndex={0}
                onClick={(e) => {
                  e.preventDefault();
                  handleOfferClick(item.id, item.offerName, item.url);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleOfferClick(item.id, item.offerName, item.url);
                  }
                }}
                style={{cursor: 'pointer'}}
                aria-label={t('EXPLORE_NOW')}
              >
                {isMobile ? (
                  <img loading="lazy" src={item.mobileImage} alt="Offer" />
                ) : (
                  <img loading="lazy" src={item.webImage} alt="Offer" />
                )}
              </div>
            </div>
          );
        });


    content = (
      <div className="customer-offer-container">
        <Carousel
          showStatus={false}
          infiniteLoop={carouselItems.length > 1}
          autoPlay={false}
          showThumbs={false}
          showArrows={carouselItems.length > 1}
          autoFocus={true}
          showIndicators={carouselItems.length > 1}
        >
          {carouselItems}
        </Carousel>
      </div>
    );
  }

  return <>{content}</>;
};
export const mapStateToProps = (state) => {
  return {
    paymentScheduleLoader: state.appStates.paymentScheduleLoader,
    validOfferCode: state.appStates.paymentSchedule?.validOfferCode,
    country: state.appStates.allContracts?.countryCode,
  };
};

CustomerOffer.propTypes = {
  paymentScheduleLoader: PropTypes.bool,
  validOfferCode: PropTypes.string,
  country: PropTypes.string,
};

export default connect(mapStateToProps)(CustomerOffer);
